
import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { config } from '@/config';

@Component({
    components: {
       DateRangePicker,
    },
})
export default class VueDateRangePicker extends Vue {
    @Prop({ default: true }) showDropdowns!: boolean;
    @Prop({ default: "right" }) opens!: string;
    @Prop({ default: true }) showWeekNumbers!: boolean;
    @Prop({ default: false }) singleDatePicker!: boolean;
    @Prop({ default: true }) autoApply!: boolean;
    @Prop({ default: true }) showRanges!: boolean;

    // TODO: should not be using object here
    @Prop({
        default: () => {
            return {
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            };
        },
    })
    dateRange!: object;

    // TODO: should not be using object here
    @Prop({
        default: () => {
            let today = new Date()
            today.setHours(0, 0, 0, 0)
            let yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            yesterday.setHours(0, 0, 0, 0);
            let last_7_days = new Date();
            last_7_days.setDate(today.getDate() - 7);
            last_7_days.setHours(0, 0, 0, 0);
            let last_14_days = new Date();
            last_14_days.setDate(today.getDate() - 14);
            last_14_days.setHours(0, 0, 0, 0);
            let last_30_days = new Date();
            last_30_days.setDate(today.getDate() - 30);
            last_30_days.setHours(0, 0, 0, 0);
            return {
                'Today': [today, today],
                'Yesterday': [yesterday, yesterday],
                'Last 7 days': [last_7_days, today],
                'Last 14 days': [last_14_days, today],
                'Last 30 days': [last_30_days, today],
                'Last month': [
                    new Date(today.getFullYear(), today.getMonth() - 1, 1), 
                    new Date(today.getFullYear(), today.getMonth(), 0)
                ],
                'This year': [
                    new Date(today.getFullYear(), 0, 1), 
                    new Date(today.getFullYear(), 11, 31)
                ],
                'All time': [
                    new Date(1970, 0, 1), 
                    new Date(9999, 11, 31)
                ],
            }
        },
    })
    ranges!: boolean|object

    // TODO: should not be using Object here
    @Prop({
        default: () => {
            return {
                format: "yyyy/mm/dd",
                separator: " - ",
            };
        },
    })
    localeData!: Object;

    created() {
        this.$emit("date-selected", {
            ...this.dateRange,
            default: true
        });
    }

    getDisplayDate(startDate: Date, endDate: Date) {

        if(startDate.toString().includes('1970')) {
            return 'All time';
        }
        return (
            moment(startDate).format("MMM D") 
            + ", " + moment(startDate).format("YYYY")
            + " - " + moment(endDate).format("MMM D")
            + ", " + moment(endDate).format("YYYY")
        );
    }

    get getCalendarLogoPath() {
        return config.baseUrl + '/img/calendar.png';
    }

    @Emit()
    dateSelected( obj: DateRangePickerDatesSelected)
        : DateRangePickerDatesSelected {
        return {
            ...obj,
            default: false
        };
    }
}
